
import { Component, OnInit, signal } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {SubtitlesService} from "../core";
import {MaintenanceAlertResponse} from "../models";

@Component({
  selector: 'app-maintenance-alert',
  templateUrl: './maintenance-alert.component.html',
  styleUrls: ['./maintenance-alert.component.scss'],
})
export class MaintenanceAlertComponent implements OnInit {
  showMaintainAlert = signal(false);
  startAlertDate = signal('');
  stopAlertDate = signal('');

  constructor(
    public subtitles: SubtitlesService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.checkMaintainDate();
  }

  subtitle(id: number): string {
    return this.subtitles.setSubtitle(id);
  }

  private checkMaintainDate(): void {
    this.http.get<MaintenanceAlertResponse>('/api/v1/maintenance_alert').subscribe({
      next: (response: MaintenanceAlertResponse) => {
        if ('is_mantaince_now' in response && response.is_mantaince_now) {
          this.showMaintainAlert.set(true);
          this.startAlertDate.set(response.start_working);
          this.stopAlertDate.set(response.end_of_working);
          return;
        }

        this.resetMaintenanceAlert();
      },
      error: () => {
        this.resetMaintenanceAlert();
      }
    });
  }

  private resetMaintenanceAlert(): void {
    this.showMaintainAlert.set(false);
    this.startAlertDate.set('');
    this.stopAlertDate.set('');
  }
}
